import clsx from 'clsx';
import styles from './MatchingBox.module.scss';
import IconButton from '../icon-button/IconButton';

function MatchingBox({
    children,
    className,
    box,
    questionType,
    audioMap,
    ...rest
}) {
    return (
        <div
            {...rest}
            className={clsx(
                styles.box,
                box.status === 'disable' && styles.disable,
                box.status === 'choosen' && styles.choosen,
                box.status === 'error' && styles.error,
                box.status === 'right' && styles.right,
                box.animationRight && styles.right,
                className,
            )}
        >
            {questionType === 'matching-listening' && box.status !== 'disable' ? (
                <div className={clsx(styles.audio)}>
                    <IconButton
                        status={
                            box.status === 'disable' ? 'disable' : 'primary'
                        }
                        className={clsx(styles.icon, 'primary')}
                    >
                        <i className="fa-solid fa-volume-high"></i>
                    </IconButton>
                </div>
            ) : (
                <div>{box.text}</div>
            )}

            {/* <div>{box.text}</div> */}
            <div
                className={clsx(
                    styles.icon,
                    box.status === 'choosen' && styles.choosen,
                    box.status === 'error' && styles.error,
                    box.status === 'right' && styles.right,
                )}
            ></div>
        </div>
    );
}
export default MatchingBox;
